"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeadCodeInjectionCustomNode = void 0;
var DeadCodeInjectionCustomNode;
(function (DeadCodeInjectionCustomNode) {
    DeadCodeInjectionCustomNode["BlockStatementDeadCodeInjectionNode"] = "BlockStatementDeadCodeInjectionNode";
})(DeadCodeInjectionCustomNode = exports.DeadCodeInjectionCustomNode || (exports.DeadCodeInjectionCustomNode = {}));
